import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-guest-casino',
  templateUrl: './casino.component.html',
  styleUrls: ['./casino.component.css'],
  host: {
    "(window:resize)": "onWindowResize($event)"
  }
})
export class CasinoComponent implements OnInit {
  modalRef?: BsModalRef;
  public api = api;
  public env = environment;
  public data: any;
  public isMobile: boolean = false;
  public iframeUrl: any = '';
  public gameName: any = '';
  constructor(public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    public _message: MessageService,
    public router: Router,
    private modalService: BsModalService) { }



  ngOnInit(): void {
    // this._shared.sharedTabCasino.subscribe((data: any) => {
    //   if (data) {
    //     this.isMobile = data.isMobile;
    //     this.getData();
    //   }
    // });
    this.getData();
  }

  width: number = window.innerWidth;
  mobileWidth: number = 768;

  onWindowResize(event: any) {
    this.width = event.target.innerWidth;    
    this.isMobile = this.width < this.mobileWidth ? true : false;
    // console.log(`${this.width}`);
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.casino1G}`).subscribe(
      (res) => {
        if (res.status == true) {
          let dt: any[] = [];
          // Object.keys(res.data.event_types).forEach((key) => { dt.push({ 'id': key, 'name': res.data.event_types[key] }) });
          // res.data.event_types = dt;
          this.data = res.data;
          console.log(this.data);
          

        } else if (res.status == false) {
          this._message.errmessage(res?.error?.message);
          this.data = []
          this.router.navigate(['/dashboard'])
        }
      },
      (err) => {
        console.log(err);
      });
  }

  openModal(template: TemplateRef<any>, item: any) {
    this.isMobile = this.width < this.mobileWidth ? true : false;
    if (this._common.getToken()) {
      if (this.isMobile) {
        this.iframeUrl = (item.id == '99999') ? this.data.mobile_link : `${this.data.mobile_link}?opentable=${item.id}`
      } else {
        this.iframeUrl = (item.id == '99999') ? this.data.web_link : `${this.data.web_link}?opentable=${item.id}`
      }
      this.iframeUrl = this._common.secureUrl(this.iframeUrl);
      this.gameName = item.name;

      this.modalRef = this.modalService.show(template,
        Object.assign({}, { class: 'ctm-modal-xl modalUI' }));
    } else {
      this._shared.emitLoginModal({ 'login': true });
    }
  }

  closeModal() {
    this.modalRef?.hide();
    this.iframeUrl = '';
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
